import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section4 = () => {
  const { t } = useTranslation();

  return (
    <motion.div
          initial="hidden"
          whileInView="visible"
          exit="exit"
          variants={containerVariants}
    
    className="grid grid-cols-10 pb-0">
      <div className="col-start-2 md:col-start-2 col-span-8 ">
        <div className="my-14  ">
          <motion.h1 variants={itemVariants} className=" text-65  text-customBlack mb-5 font-light">
            {t("rnd.contributions.title")}
            <br />
            <span className="font-medium">{t("rnd.contributions.subtitle")}</span>
          </motion.h1>

          <div className="w-[80%]">
            <div className="flex flex-col text-20 font-light text-customGray mb-14">
              <motion.h2 variants={itemVariants} className="font-bold">{t("rnd.contributions.innovation.title")}</motion.h2>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.innovation.text1")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.innovation.text2")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.innovation.text3")}
              </motion.p>
            </div>

            <div className="flex flex-col text-20 font-light text-customGray mb-14">
              <motion.h2 variants={itemVariants} className="font-bold">{t("rnd.contributions.technology.title")}</motion.h2>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.technology.text1")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.technology.text2")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.technology.text3")}
              </motion.p>
            </div>

            <div className="flex flex-col text-20 font-light text-customGray mb-14">
              <motion.h2 variants={itemVariants} className="font-bold">{t("rnd.contributions.partnerships.title")}</motion.h2>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.partnerships.text1")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.partnerships.text2")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.partnerships.text3")}
              </motion.p>
            </div>

            <div className="flex flex-col text-20 font-light text-customGray mb-14">
              <motion.h2 variants={itemVariants} className="font-bold">{t("rnd.contributions.humanResource.title")}</motion.h2>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.humanResource.text1")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.humanResource.text2")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.humanResource.text3")}
              </motion.p>
              <motion.p variants={itemVariants}>
                {t("rnd.contributions.humanResource.text4")}
              </motion.p>
            </div>

            <motion.h5 variants={itemVariants} className="text-45 font-thin">
              {t("rnd.contributions.slogan")}
            </motion.h5>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Section4;
